import React, { Fragment } from 'react'
import LargeGrid from '@icons/LargeGrid.jsx'
import SmallGrid from '@icons/SmallGrid.jsx'

import useWindowDimensions from '@hooks/useWindowDimensions.js'

const GridSelect = ({ gridSize, handleGridSelect }) => {
    const { windowWidth, windowHeight } = useWindowDimensions()

    return (
        <Fragment>
            {windowWidth && windowWidth >= 1280 ? (
                <div className="grid-select-outer ml-auto mr-5">
                    <div className="grid-select-inner">
                        <div className="grid-select flex items-center gap-1">
                            <div
                                className={`large-grid flex items-center justify-center p-3 mx-auto h-8 w-8 ${
                                    gridSize === 'large'
                                        ? 'rounded-full border-2 border-flint'
                                        : ''
                                }`}
                                onClick={() => handleGridSelect('large')}
                            >
                                <LargeGrid width="w-[18px]" />
                            </div>
                            <div
                                className={`small-grid flex items-center justify-center p-3 mx-auto h-8 w-8 ${
                                    gridSize === 'small'
                                        ? 'rounded-full border-2 border-flint'
                                        : ''
                                }`}
                                onClick={() => handleGridSelect('small')}
                            >
                                <SmallGrid width="w-[24px]" />
                            </div>
                        </div>
                    </div>
                </div>
            ) : null}
        </Fragment>
    )
}

export default GridSelect
